import { gql, useQuery } from 'urql'

const SEARCH_TRACKING_SESSION_QUERY = gql`
  query FetchTrackingSession {
    search: getSearchTrackingSession {
      sessionToken
      sessionId
    }
    km: getKmTrackingSession {
      sessionToken
      sessionId
    }
  }
`

type InbentaTrackingSession = {
  sessionToken: string
  sessionId: string
}

type Props = {
  search: InbentaTrackingSession
  km: InbentaTrackingSession
}

export const useSearchTrackingSession = (): Props => {
  const [result] = useQuery({ query: SEARCH_TRACKING_SESSION_QUERY })
  return result.data
}
